import React from "react";
import "react-toggle/style.css";
import Toggle from "react-toggle";

const resultsPerPage = 15;
const chunk = (arr, size) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
    arr.slice(i * size, i * size + size)
  );

const Search = ({ data, handleData }) => {
  const [value, setValue] = React.useState("");

  React.useEffect(() => {
    if (value && data && data.length) {
      let arr = data
        .map(
          (val) =>
            (val.email.toLowerCase().includes(value.toLowerCase()) ||
              val.fullName.toLowerCase().includes(value.toLowerCase())) &&
            val
        )
        .filter((r) => r);

      let chunkedArr = chunk(arr || [], resultsPerPage);
      handleData(chunkedArr);
    }
  }, [value]);

  return (
    <input
      style={{ width: "100%", margin: "12px 0", padding: "12px 20px" }}
      type="text"
      id="header-search"
      placeholder="Sök efter användare"
      name="s"
      value={value}
      onChange={(event) => setValue(event.target.value)}
    />
  );
};

const GroupSearch = ({ data, handleData }) => {
  const [value, setValue] = React.useState("");

  React.useEffect(() => {
    if (value && data && data.length) {
      let arr = data
        .map(
          (val) =>
            (val.name.toLowerCase().includes(value.toLowerCase()) ||
              val.tag.toLowerCase().includes(value.toLowerCase())) &&
            val
        )
        .filter((r) => r);

      let chunkedArr = chunk(arr || [], resultsPerPage);
      handleData(chunkedArr);
    }
  }, [value]);

  return (
    <input
      style={{ width: "100%", margin: "12px 0", padding: "12px 20px" }}
      type="text"
      id="header-search"
      placeholder="Sök efter grupper"
      name="s"
      value={value}
      onChange={(event) => setValue(event.target.value)}
    />
  );
};

const DataField = ({ label, value, onChange }) => {
  const [val, setVal] = React.useState(value);

  React.useEffect(() => {
    if (val !== undefined && val !== null) {
      onChange(val);
    }
  }, [val]);

  return (
    <div
      style={{
        width: "100%",
        padding: "4px 10px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <p style={{ fontWeight: 700, width: 140 }}>{label || "text"}:</p>
      <input
        style={{ flex: 1, padding: "6px 10px", height: 50 }}
        type="text"
        placeholder={label}
        name={label}
        value={val}
        onChange={(event) => setVal(event.target.value)}
      />
    </div>
  );
};

const TrueFalseField = ({ label, value, onChange }) => {
  const [val, setVal] = React.useState(value);

  React.useEffect(() => {
    if (val !== undefined && val !== null) {
      onChange(val);
    }
  }, [val]);

  return (
    <div
      style={{
        width: "100%",
        padding: "4px 10px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <p style={{ fontWeight: 700, marginRight: 12 }}>{label || "text"}:</p>
      <Toggle
        defaultChecked={val}
        onChange={(event) => setVal(event.target.checked)}
      />
    </div>
  );
};

const Group = ({ data, fetchBranteverestGroupUpdate }) => {
  const [state, setState] = React.useState(data);
  if (data && data.constructor === Object && Object.entries(data)?.length) {
    return (
      <div
        style={{
          flex: 1,
          margin: 32,
          padding: 32,
          display: "flex",
          position: "relative",
          flexDirection: "column",
        }}
      >
        <div
          style={{ display: "flex", alignItems: "center", marginBottom: 20 }}
        >
          <h2 style={{ marginRight: 6 }}>{state?.name || "Grupp"} -</h2>
          <h1>#{state?._id || "ID"}</h1>
        </div>
        <DataField
          label="Namn"
          value={data.name}
          onChange={(val) => setState({ ...state, name: val })}
        />
        <DataField
          label="Tagg"
          value={data.tag}
          onChange={(val) => setState({ ...state, tag: val })}
        />
        <DataField
          label="Beskrivning"
          value={data.description}
          onChange={(val) => setState({ ...state, description: val })}
        />
        <DataField
          label="Genomsnitt poäng"
          value={data.averageScore}
          onChange={(val) => setState({ ...state, averageScore: val })}
        />
        <DataField
          label="Mängd medlemmar"
          value={data.numMembers}
          onChange={(val) => setState({ ...state, numMembers: val })}
        />
        <DataField
          label="Mängd konton skapade via gruppens kod"
          value={data.numCreatedAccounts}
          onChange={(val) => setState({ ...state, numCreatedAccounts: val })}
        />
        <DataField
          label="Mängd koder som kan aktiveras för gruppen"
          value={data.numCodes}
          onChange={(val) => setState({ ...state, numCodes: val })}
        />
        <DataField
          label="Kod"
          value={data.id}
          onChange={(val) => setState({ ...state, id: val })}
        />

        <div style={{ position: "absolute", top: 32, right: 32 }}>
          {Object.entries(data).toString() ===
          Object.entries(state).toString() ? (
            <button
              style={{
                ...buttonStyle,
                backgroundColor: "rgb(250, 250, 250)",
                color: "#000",
              }}
              //onClick={() => console.log('spara')}
            >
              spara
            </button>
          ) : (
            <button
              style={{
                ...buttonStyle,
              }}
              onClick={() => fetchBranteverestGroupUpdate(state)}
            >
              spara
            </button>
          )}
        </div>
      </div>
    );
  }

  return null;
};

const CreateGroup = ({ createGroupFunc, menu }) => {
  const [state, setState] = React.useState({
    name: "",
    tag: "",
    description: "",
    numCodes: 0,
  });

  return (
    <div
      style={{
        flex: 1,
        margin: 32,
        padding: 32,
        display: "flex",
        position: "relative",
        flexDirection: "column",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", marginBottom: 20 }}>
        <h2 style={{ marginRight: 6 }}>
          Skapa grupp - {menu === 0 ? "Bränteverest" : "Lundarundan"}
        </h2>
      </div>
      <DataField
        label="Namn"
        value={state.name}
        onChange={(val) => setState({ ...state, name: val })}
      />
      <DataField
        label="Tagg"
        value={state.tag}
        onChange={(val) => setState({ ...state, tag: val })}
      />
      <DataField
        label="Beskrivning"
        value={state.description}
        onChange={(val) => setState({ ...state, description: val })}
      />
      <DataField
        label="Mängd koder som kan aktiveras för gruppen"
        value={state.numCodes}
        onChange={(val) => setState({ ...state, numCodes: val })}
      />

      <div style={{ position: "absolute", top: 32, right: 32 }}>
        {!(state.name && state.tag && state.numCodes && state.description) ? (
          <button
            style={{
              ...buttonStyle,
              backgroundColor: "rgb(250, 250, 250)",
              color: "#000",
            }}
            //onClick={() => console.log('spara')}
          >
            skapa
          </button>
        ) : (
          <button
            style={{
              ...buttonStyle,
            }}
            onClick={() => createGroupFunc(state)}
          >
            skapa
          </button>
        )}
      </div>
    </div>
  );
};

const User = ({ data, fetchBranteverestUserUpdate }) => {
  const [state, setState] = React.useState(data);
  if (data && data.constructor === Object && Object.entries(data)?.length) {
    return (
      <div
        style={{
          flex: 1,
          margin: 32,
          padding: 32,
          display: "flex",
          position: "relative",
          flexDirection: "column",
        }}
      >
        <div
          style={{ display: "flex", alignItems: "center", marginBottom: 20 }}
        >
          <h2 style={{ marginRight: 6 }}>{state?.fullName || "Användare"} -</h2>
          <h1>#{state?._id || "ID"}</h1>
        </div>
        <DataField
          label="Förnamn"
          value={data.firstName}
          onChange={(val) => setState({ ...state, firstName: val })}
        />
        <DataField
          label="Efternamn"
          value={data.lastName}
          onChange={(val) => setState({ ...state, lastName: val })}
        />
        <DataField
          label="Fullt Namn"
          value={data.fullName}
          onChange={(val) => setState({ ...state, fullName: val })}
        />
        <DataField
          label="Email"
          value={data.email}
          onChange={(val) => setState({ ...state, email: val })}
        />
        <DataField
          label="Totala poäng"
          value={data.totalScore}
          onChange={(val) => setState({ ...state, totalScore: val })}
        />
        <DataField
          label="Måndens poäng"
          value={data.monthlyScore}
          onChange={(val) => setState({ ...state, monthlyScore: val })}
        />
        <DataField
          label="Veckans poäng"
          value={data.weeklyScore}
          onChange={(val) => setState({ ...state, weeklyScore: val })}
        />
        <DataField
          label="Dagens poäng"
          value={data.dailyScore}
          onChange={(val) => setState({ ...state, dailyScore: val })}
        />
        <DataField
          label="GruppID"
          value={data.groupId}
          onChange={(val) => setState({ ...state, groupId: val })}
        />
        <DataField
          label="GruppTAGG"
          value={data.groupTag}
          onChange={(val) => setState({ ...state, groupTag: val })}
        />
        <DataField
          label="Användar ID"
          value={data.id}
          onChange={(val) => setState({ ...state, id: val })}
        />
        <DataField
          label="OrderId"
          value={data.orderId}
          onChange={(val) => setState({ ...state, orderId: val })}
        />
        <DataField
          label="Betalningssätt"
          value={data.purchaseId}
          onChange={(val) => setState({ ...state, purchaseId: val })}
        />
        <DataField
          label="Mängd medaljer"
          value={data.numAchievements}
          onChange={(val) => setState({ ...state, numAchievements: val })}
        />
        <TrueFalseField
          label="Är gömd från topplistan"
          value={data.isHidden}
          onChange={(val) => setState({ ...state, isHidden: val })}
        />
        <TrueFalseField
          label="Har betalat"
          value={data.hasPaid}
          onChange={(val) => setState({ ...state, hasPaid: val })}
        />
        <TrueFalseField
          label="Lokal data"
          value={data.localData}
          onChange={(val) => setState({ ...state, localData: val })}
        />

        <div style={{ position: "absolute", top: 32, right: 32 }}>
          {Object.entries(data).toString() ===
          Object.entries(state).toString() ? (
            <button
              style={{
                ...buttonStyle,
                backgroundColor: "rgb(250, 250, 250)",
                color: "#000",
              }}
              //onClick={() => console.log('spara')}
            >
              spara
            </button>
          ) : (
            <button
              style={{
                ...buttonStyle,
              }}
              onClick={() => fetchBranteverestUserUpdate(state)}
            >
              spara
            </button>
          )}
        </div>
      </div>
    );
  }

  return null;
};

const Loading = () => (
  <div className="sk-circle">
    <div className="sk-circle1 sk-child"></div>
    <div className="sk-circle2 sk-child"></div>
    <div className="sk-circle3 sk-child"></div>
    <div className="sk-circle4 sk-child"></div>
    <div className="sk-circle5 sk-child"></div>
    <div className="sk-circle6 sk-child"></div>
    <div className="sk-circle7 sk-child"></div>
    <div className="sk-circle8 sk-child"></div>
    <div className="sk-circle9 sk-child"></div>
    <div className="sk-circle10 sk-child"></div>
    <div className="sk-circle11 sk-child"></div>
    <div className="sk-circle12 sk-child"></div>
  </div>
);

const buttonStyle = {
  fontSize: 14,
  letterSpacing: 0.5,
  padding: "14px 32px",
  height: "initial",
  width: "initial",
};

export default (props) => {
  const [menu, setMenu] = React.useState(null);
  const [secondMenu, setSecondMenu] = React.useState(null);
  const [state, setState] = React.useState({ isLoading: false, page: 0 });

  const fetchBranteverest = async () => {
    fetch(props.url + "/api/admin/getStats", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: props.token,
      }),
    })
      .then((res) => res.json())
      .then((json) =>
        setState({ ...state, branteverest: json, isLoading: false })
      );
  };
  const fetchLundarundan = async () => {
    fetch(props.url + "/api/lundarundan/admin/getStats", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: props.token,
      }),
    })
      .then((res) => res.json())
      .then((json) =>
        setState({ ...state, lundarundan: json, isLoading: false })
      );
  };

  const fetchBranteverestUserUpdate = async (data) => {
    setState({ ...state, isLoading: true });
    fetch(props.url + "/api/admin/updateUser", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: props.token,
        ...data,
      }),
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          let userArr = state.branteverest.users.map((obj) =>
            obj._id === json.user._id ? json.user : obj
          );
          let chunkedArr = chunk(userArr || [], resultsPerPage);

          setState({
            ...state,
            branteverest: { ...state.branteverest, users: userArr },
            currentUser: json.user,
            brantUsers: chunkedArr,
            page: 0,
            isLoading: false,
          });
        } else {
          setState({ ...state, isLoading: false });
          alert("Gick inte att uppdatera användaren. " + (json.mes || ""));
        }
      });
  };

  const createBranteverestGroup = async (data) => {
    setState({ ...state, isLoading: true });
    fetch(props.url + "/api/admin/createGroup", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: props.token,
        ...data,
      }),
    })
      .then((res) => res.json())
      .then((json) => {
        console.log(json);
        if (json.success) {
          let groupArr = [json.group, ...state.branteverest.groups];
          let chunkedArr = chunk(groupArr || [], resultsPerPage);

          setState({
            ...state,
            branteverest: { ...state.branteverest, groups: groupArr },
            currentGroup: json.group,
            brantGroups: chunkedArr,
            page: 0,
            isLoading: false,
          });
          setSecondMenu(4);
        } else {
          setState({ ...state, isLoading: false });
          alert("Gick inte att skapa gruppen. " + (json.mes || ""));
        }
      });
  };

  const createLundarundanGroup = async (data) => {
    setState({ ...state, isLoading: true });
    fetch(props.url + "/api/lundarundan/admin/createGroup", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: props.token,
        ...data,
      }),
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          let groupArr = [json.group, ...state.lundarundan.groups];
          let chunkedArr = chunk(groupArr || [], resultsPerPage);

          setState({
            ...state,
            lundarundan: { ...state.lundarundan, groups: groupArr },
            currentGroup: json.group,
            lundaGroups: chunkedArr,
            page: 0,
            isLoading: false,
          });
          setSecondMenu(4);
        } else {
          setState({ ...state, isLoading: false });
          alert("Gick inte att skapa gruppen. " + (json.mes || ""));
        }
      });
  };

  const fetchLundarundanUserUpdate = async (data) => {
    setState({ ...state, isLoading: true });
    fetch(props.url + "/api/lundarundan/admin/updateUser", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: props.token,
        ...data,
      }),
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          let userArr = state.lundarundan.users.map((obj) =>
            obj._id === json.user._id ? json.user : obj
          );
          let chunkedArr = chunk(userArr || [], resultsPerPage);

          setState({
            ...state,
            lundarundan: { ...state.lundarundan, users: userArr },
            currentUser: json.user,
            lundaUsers: chunkedArr,
            page: 0,
            isLoading: false,
          });
        } else {
          setState({ ...state, isLoading: false });
          alert("Gick inte att uppdatera användaren. " + (json.mes || ""));
        }
      });
  };

  const fetchLundarundanGroupUpdate = async (data) => {
    setState({ ...state, isLoading: true });
    fetch(props.url + "/api/lundarundan/admin/updateGroup", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: props.token,
        ...data,
      }),
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          let groupArr = state.lundarundan.groups.map((obj) =>
            obj._id === json.group._id ? json.group : obj
          );
          let chunkedArr = chunk(groupArr || [], resultsPerPage);

          setState({
            ...state,
            lundarundan: { ...state.lundarundan, groups: groupArr },
            currentGroup: json.group,
            lundaGroups: chunkedArr,
            page: 0,
            isLoading: false,
          });
        } else {
          setState({ ...state, isLoading: false });
          alert("Gick inte att uppdatera gruppen. " + (json.mes || ""));
        }
      });
  };

  const fetchBranteverestGroupUpdate = async (data) => {
    setState({ ...state, isLoading: true });
    fetch(props.url + "/api/admin/updateGroup", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: props.token,
        ...data,
      }),
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          let groupArr = state.branteverest.groups.map((obj) =>
            obj._id === json.group._id ? json.group : obj
          );
          let chunkedArr = chunk(groupArr || [], resultsPerPage);

          setState({
            ...state,
            branteverest: { ...state.branteverest, groups: groupArr },
            currentGroup: json.group,
            brantGroups: chunkedArr,
            page: 0,
            isLoading: false,
          });
        } else {
          setState({ ...state, isLoading: false });
          alert("Gick inte att uppdatera gruppen. " + (json.mes || ""));
        }
      });
  };

  const formatBranteverest = () =>
    setState({
      ...state,
      brantUsers: chunk(state?.branteverest?.users || [], resultsPerPage),
      brantGroups: chunk(state?.branteverest?.groups || [], resultsPerPage),
      isLoading: false,
    });
  const formatLundarundan = () =>
    setState({
      ...state,
      lundaUsers: chunk(state?.lundarundan?.users || [], resultsPerPage),
      lundaGroups: chunk(state?.lundarundan?.groups || [], resultsPerPage),
      isLoading: false,
    });

  React.useEffect(() => {
    if (secondMenu !== null) {
      if (secondMenu === 1 || secondMenu === 2) {
        if (menu === 0) {
          //branteverest användare
          if (!state?.brantUsers) {
            setState({ ...state, isLoading: true });
            formatBranteverest();
          } else {
            setState({
              ...state,
              brantUserSearch: [],
              brantGroupSearch: [],
              page: 0,
            });
          }
        } else {
          //lundarundan användare
          if (!state?.lundaUsers) {
            setState({ ...state, isLoading: true });
            formatLundarundan();
          } else {
            setState({
              ...state,
              lundaUserSearch: [],
              lundaGroupSearch: [],
              page: 0,
            });
          }
        }
      }
    }
  }, [secondMenu]);

  React.useEffect(() => {
    if (menu === 0) {
      if (!state?.branteverest) {
        setState({ ...state, isLoading: true });
        fetchBranteverest();
      }
    } else if (menu === 1) {
      if (!state?.lundarundan) {
        setState({ ...state, isLoading: true });
        fetchLundarundan();
      }
    }
  }, [menu]);

  return (
    <div style={{ flex: 1, flexDirection: "row", padding: 0, marginLeft: 0 }}>
      <div
        style={{
          flex: 0.15,
          minWidth: 200,
          padding: 0,
          backgroundColor: "#FFF",
          display: "flex",
          flexDirection: "column",
          borderRight: "2px solid #cccccc",
        }}
      >
        <div
          style={
            menu === 0
              ? {
                  height: 100,

                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 20,
                  backgroundColor: "#cccccc",
                }
              : {
                  height: 100,

                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 20,
                  backgroundColor: "#f0f0f0",
                }
          }
          onClick={() => setMenu(0)}
        >
          <p style={{ fontSize: 24, textAlign: "center" }}>Bränteverest</p>
        </div>
        <div
          style={
            menu === 1
              ? {
                  height: 100,

                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  marginBottom: 20,
                  backgroundColor: "#cccccc",
                }
              : {
                  height: 100,

                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 20,
                  backgroundColor: "#f0f0f0",
                }
          }
          onClick={() => setMenu(1)}
        >
          <p style={{ fontSize: 24, textAlign: "center" }}>Lundarundan</p>
        </div>
      </div>
      {menu !== null && (
        <div
          style={{
            flex: 0.15,
            minWidth: 150,

            padding: 0,
            paddingTop: 75,
            display: "flex",
            backgroundColor: "#fafafa",
            flexDirection: "column",
            borderRight: "2px solid #cccccc",
          }}
        >
          <div
            style={
              secondMenu === 0 || secondMenu === null
                ? {
                    height: 100,

                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: 20,
                    backgroundColor: "#cccccc",
                  }
                : {
                    height: 100,

                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: 20,
                    backgroundColor: "#f0f0f0",
                  }
            }
            onClick={() => setSecondMenu(0)}
          >
            <p style={{ fontSize: 20, textAlign: "center" }}>Statistik</p>
          </div>
          <div
            style={
              secondMenu === 1
                ? {
                    height: 100,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: 20,
                    backgroundColor: "#cccccc",
                  }
                : {
                    height: 100,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: 20,
                    backgroundColor: "#f0f0f0",
                  }
            }
            onClick={() => {
              setState({ ...state, page: 0 });
              setSecondMenu(1);
            }}
          >
            <p style={{ fontSize: 20, textAlign: "center" }}>Användare</p>
          </div>
          <div
            style={
              secondMenu === 2
                ? {
                    height: 100,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: 20,
                    backgroundColor: "#cccccc",
                  }
                : {
                    height: 100,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: 20,
                    backgroundColor: "#f0f0f0",
                  }
            }
            onClick={() => {
              setState({ ...state, page: 0 });
              setSecondMenu(2);
            }}
          >
            <p style={{ fontSize: 20, textAlign: "center" }}>Grupper</p>
          </div>
        </div>
      )}
      {menu === null ? (
        <p
          style={{
            fontSize: 24,
            textAlign: "center",
            alignSelf: "center",
            justifySelf: "center",
          }}
        >
          Välj mellan bränteverest och lundarundan i menyn.
        </p>
      ) : (
        <div
          style={{
            display: "flex",
            flex: 1,
            padding: 32,
            position: "relative",
            paddingBottom: 100,
            flexDirection: "column",
          }}
        >
          {state?.isLoading === true ? (
            <Loading />
          ) : menu === 0 ? (
            secondMenu === 0 || secondMenu === null ? (
              <div>
                <p>
                  * Statistik är från nuvarande utmaning om det inte står
                  annorlunda
                </p>
                {state?.branteverest?.stats?.map((val, i) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ fontWeight: "bold" }}>{val.title}:</p>
                    <p style={{ marginLeft: 10, marginTop: 0 }}>{val.value}</p>
                  </div>
                ))}
              </div>
            ) : secondMenu === 1 ? (
              !state?.brantUsers ? (
                <Loading />
              ) : (
                <div>
                  <Search
                    data={state?.branteverest?.users || []}
                    handleData={(result) => {
                      setState({
                        ...state,
                        brantUserSearch: result,
                        page: 0,
                      });
                    }}
                  />
                  {state?.brantUsers && state?.brantUsers?.length ? (
                    state?.brantUserSearch && state?.brantUserSearch?.length ? (
                      state?.brantUserSearch[state.page || 0].map((val, i) => (
                        <div
                          key={val._id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            height: 60,
                            backgroundColor: i % 2 === 0 && "#f1feff",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flex: 1,
                              alignItems: "center",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              margin: "0 -32px",
                              padding: "0 48px",
                            }}
                          >
                            <p>{i + (state.page || 0) * resultsPerPage}</p>
                            <p style={{ fontWeight: 700, margin: 0 }}>
                              {val.email}
                            </p>
                            <p style={{ margin: 0 }}>{val.fullName}</p>
                            <button
                              style={buttonStyle}
                              onClick={() => {
                                setState({
                                  ...state,
                                  currentUser: val,
                                  page: 0,
                                });
                                setSecondMenu(3);
                              }}
                            >
                              öppna
                            </button>
                          </div>
                        </div>
                      ))
                    ) : (
                      state?.brantUsers[state.page || 0].map((val, i) => (
                        <div
                          key={val._id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            height: 60,
                            backgroundColor: i % 2 === 0 && "#f1feff",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flex: 1,
                              alignItems: "center",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              margin: "0 -32px",
                              padding: "0 48px",
                            }}
                          >
                            <p>{i + (state.page || 0) * resultsPerPage}</p>
                            <p style={{ fontWeight: 700, margin: 0 }}>
                              {val.email}
                            </p>
                            <p style={{ margin: 0 }}>{val.fullName}</p>
                            <button
                              style={buttonStyle}
                              onClick={() => {
                                setState({
                                  ...state,
                                  currentUser: val,
                                  page: 0,
                                });
                                setSecondMenu(3);
                              }}
                            >
                              öppna
                            </button>
                          </div>
                        </div>
                      ))
                    )
                  ) : (
                    <Loading />
                  )}
                  {(state.page || 0) > 0 && !state?.brantUserSearch?.length && (
                    <button
                      style={{
                        ...buttonStyle,
                        position: "absolute",
                        left: 32,
                        bottom: 32,
                      }}
                      onClick={() =>
                        setState({ ...state, page: (state.page || 0) - 1 })
                      }
                    >
                      tidigare
                    </button>
                  )}
                  {(state.page || 0) < state?.brantUsers.length - 1 &&
                    !state?.brantUserSearch?.length && (
                      <button
                        style={{
                          ...buttonStyle,
                          position: "absolute",
                          right: 32,
                          bottom: 32,
                        }}
                        onClick={() =>
                          setState({ ...state, page: (state.page || 0) + 1 })
                        }
                      >
                        nästa
                      </button>
                    )}
                </div>
              )
            ) : secondMenu === 2 ? (
              !state?.brantGroups ? (
                <Loading />
              ) : (
                <div>
                  <GroupSearch
                    data={state?.branteverest?.groups || []}
                    handleData={(result) => {
                      setState({
                        ...state,
                        brantGroupSearch: result,
                        page: 0,
                      });
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      paddingVertical: 6,
                      alignItems: "center",
                      marginBottom: 10,
                    }}
                  >
                    <h2>Grupper</h2>
                    <div
                      onClick={() => setSecondMenu(5)}
                      style={{
                        display: "flex",
                        borderRadius: 100,
                        marginLeft: 16,
                        height: 30,
                        width: 30,
                        backgroundColor: "green",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <p style={{ color: "#FFF", fontSize: 26 }}>+</p>
                    </div>
                  </div>

                  {state?.brantGroups && state?.brantGroups?.length ? (
                    state?.brantGroupSearch?.length ? (
                      state?.brantGroupSearch[state.page || 0].map((val, i) => (
                        <div
                          key={val._id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            height: 60,
                            backgroundColor: i % 2 === 0 && "#f1feff",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flex: 1,
                              alignItems: "center",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              margin: "0 -32px",
                              padding: "0 48px",
                            }}
                          >
                            <p>{i + (state.page || 0) * resultsPerPage}</p>
                            <p style={{ fontWeight: 700, margin: 0 }}>
                              {val.name}
                            </p>
                            <p style={{ margin: 0 }}>{val.id}</p>
                            <button
                              style={buttonStyle}
                              onClick={() => {
                                setState({
                                  ...state,
                                  currentGroup: val,
                                  page: 0,
                                });
                                setSecondMenu(4);
                              }}
                            >
                              öppna
                            </button>
                          </div>
                        </div>
                      ))
                    ) : (
                      state?.brantGroups[state.page || 0].map((val, i) => (
                        <div
                          key={val._id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            height: 60,
                            backgroundColor: i % 2 === 0 && "#f1feff",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flex: 1,
                              alignItems: "center",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              margin: "0 -32px",
                              padding: "0 48px",
                            }}
                          >
                            <p>{i + (state.page || 0) * resultsPerPage}</p>
                            <p style={{ fontWeight: 700, margin: 0 }}>
                              {val.name}
                            </p>
                            <p style={{ margin: 0 }}>{val.id}</p>
                            <button
                              style={buttonStyle}
                              onClick={() => {
                                setState({
                                  ...state,
                                  currentGroup: val,
                                  page: 0,
                                });
                                setSecondMenu(4);
                              }}
                            >
                              öppna
                            </button>
                          </div>
                        </div>
                      ))
                    )
                  ) : (
                    <Loading />
                  )}
                  {(state.page || 0) > 0 && !state?.brantGroupSearch?.length && (
                    <button
                      style={{
                        ...buttonStyle,
                        position: "absolute",
                        left: 32,
                        bottom: 32,
                      }}
                      onClick={() =>
                        setState({ ...state, page: (state.page || 0) - 1 })
                      }
                    >
                      tidigare
                    </button>
                  )}
                  {(state.page || 0) < state?.brantGroups.length - 1 &&
                    !state?.brantGroupSearch &&
                    !state?.brantGroupSearch?.length && (
                      <button
                        style={{
                          ...buttonStyle,
                          position: "absolute",
                          right: 32,
                          bottom: 32,
                        }}
                        onClick={() =>
                          setState({ ...state, page: (state.page || 0) + 1 })
                        }
                      >
                        nästa
                      </button>
                    )}
                </div>
              )
            ) : secondMenu === 3 ? (
              !state?.currentUser ? (
                <Loading />
              ) : (
                <User
                  data={state.currentUser}
                  fetchBranteverestUserUpdate={fetchBranteverestUserUpdate}
                />
              )
            ) : secondMenu === 4 ? (
              !state?.currentGroup ? (
                <Loading />
              ) : (
                <Group
                  data={state.currentGroup}
                  fetchBranteverestGroupUpdate={fetchBranteverestGroupUpdate}
                />
              )
            ) : (
              <CreateGroup
                createGroupFunc={createBranteverestGroup}
                menu={menu}
              />
            )
          ) : (
            // LUNDARUNDAN ////
            menu === 1 &&
            (secondMenu === 0 || secondMenu === null ? (
              <div>
                <p>
                  * Statistik är från nuvarande utmaning om det inte står
                  annorlunda
                </p>
                {state?.lundarundan?.stats?.map((val, i) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ fontWeight: "bold" }}>{val.title}:</p>
                    <p style={{ marginLeft: 10, marginTop: 0 }}>{val.value}</p>
                  </div>
                ))}
              </div>
            ) : secondMenu === 1 ? (
              !state?.lundaUsers ? (
                <Loading />
              ) : (
                <div>
                  <Search
                    data={state?.lundarundan?.users || []}
                    handleData={(result) => {
                      setState({
                        ...state,
                        lundaUserSearch: result,
                        page: 0,
                      });
                    }}
                  />
                  {state?.lundaUsers && state?.lundaUsers?.length ? (
                    state?.lundaUserSearch && state?.lundaUserSearch?.length ? (
                      state?.lundaUserSearch[state.page || 0].map((val, i) => (
                        <div
                          key={val._id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            height: 60,
                            backgroundColor: i % 2 === 0 && "#f1feff",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flex: 1,
                              alignItems: "center",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              margin: "0 -32px",
                              padding: "0 48px",
                            }}
                          >
                            <p>{i + (state.page || 0) * resultsPerPage}</p>
                            <p style={{ fontWeight: 700, margin: 0 }}>
                              {val.email}
                            </p>
                            <p style={{ margin: 0 }}>{val.fullName}</p>
                            <button
                              style={buttonStyle}
                              onClick={() => {
                                setState({
                                  ...state,
                                  currentUser: val,
                                  page: 0,
                                });
                                setSecondMenu(3);
                              }}
                            >
                              öppna
                            </button>
                          </div>
                        </div>
                      ))
                    ) : (
                      state?.lundaUsers[state.page || 0].map((val, i) => (
                        <div
                          key={val._id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            height: 60,
                            backgroundColor: i % 2 === 0 && "#f1feff",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flex: 1,
                              alignItems: "center",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              margin: "0 -32px",
                              padding: "0 48px",
                            }}
                          >
                            <p>{i + (state.page || 0) * resultsPerPage}</p>
                            <p style={{ fontWeight: 700, margin: 0 }}>
                              {val.email}
                            </p>
                            <p style={{ margin: 0 }}>{val.fullName}</p>
                            <button
                              style={buttonStyle}
                              onClick={() => {
                                setState({
                                  ...state,
                                  currentUser: val,
                                  page: 0,
                                });
                                setSecondMenu(3);
                              }}
                            >
                              öppna
                            </button>
                          </div>
                        </div>
                      ))
                    )
                  ) : (
                    <Loading />
                  )}
                  {(state.page || 0) > 0 && !state?.lundaUserSearch?.length && (
                    <button
                      style={{
                        ...buttonStyle,
                        position: "absolute",
                        left: 32,
                        bottom: 32,
                      }}
                      onClick={() =>
                        setState({ ...state, page: (state.page || 0) - 1 })
                      }
                    >
                      tidigare
                    </button>
                  )}
                  {(state.page || 0) < state?.lundaUsers.length - 1 &&
                    !state?.lundaUserSearch?.length && (
                      <button
                        style={{
                          ...buttonStyle,
                          position: "absolute",
                          right: 32,
                          bottom: 32,
                        }}
                        onClick={() =>
                          setState({ ...state, page: (state.page || 0) + 1 })
                        }
                      >
                        nästa
                      </button>
                    )}
                </div>
              )
            ) : secondMenu === 2 ? (
              !state?.lundaGroups ? (
                <Loading />
              ) : (
                <div>
                  <GroupSearch
                    data={state?.lundarundan?.groups || []}
                    handleData={(result) => {
                      setState({
                        ...state,
                        lundaGroupSearch: result,
                        page: 0,
                      });
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      paddingVertical: 6,
                      alignItems: "center",
                      marginBottom: 10,
                    }}
                  >
                    <h2>Grupper</h2>
                    <div
                      onClick={() => setSecondMenu(5)}
                      style={{
                        display: "flex",
                        borderRadius: 100,
                        marginLeft: 16,
                        height: 30,
                        width: 30,
                        backgroundColor: "green",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <p style={{ color: "#FFF", fontSize: 26 }}>+</p>
                    </div>
                  </div>
                  {state?.lundaGroups && state?.lundaGroups?.length ? (
                    state?.lundaGroupSearch?.length ? (
                      state?.lundaGroupSearch[state.page || 0].map((val, i) => (
                        <div
                          key={val._id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            height: 60,
                            backgroundColor: i % 2 === 0 && "#f1feff",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flex: 1,
                              alignItems: "center",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              margin: "0 -32px",
                              padding: "0 48px",
                            }}
                          >
                            <p>{i + (state.page || 0) * resultsPerPage}</p>
                            <p style={{ fontWeight: 700, margin: 0 }}>
                              {val.name}
                            </p>
                            <p style={{ margin: 0 }}>{val.id}</p>
                            <button
                              style={buttonStyle}
                              onClick={() => {
                                setState({
                                  ...state,
                                  currentGroup: val,
                                  page: 0,
                                });
                                setSecondMenu(4);
                              }}
                            >
                              öppna
                            </button>
                          </div>
                        </div>
                      ))
                    ) : (
                      state?.lundaGroups[state.page || 0].map((val, i) => (
                        <div
                          key={val._id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            height: 60,
                            backgroundColor: i % 2 === 0 && "#f1feff",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flex: 1,
                              alignItems: "center",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              margin: "0 -32px",
                              padding: "0 48px",
                            }}
                          >
                            <p>{i + (state.page || 0) * resultsPerPage}</p>
                            <p style={{ fontWeight: 700, margin: 0 }}>
                              {val.name}
                            </p>
                            <p style={{ margin: 0 }}>{val.id}</p>
                            <button
                              style={buttonStyle}
                              onClick={() => {
                                setState({
                                  ...state,
                                  currentGroup: val,
                                  page: 0,
                                });
                                setSecondMenu(4);
                              }}
                            >
                              öppna
                            </button>
                          </div>
                        </div>
                      ))
                    )
                  ) : (
                    <Loading />
                  )}
                  {(state.page || 0) > 0 && !state?.lundaGroupSearch?.length && (
                    <button
                      style={{
                        ...buttonStyle,
                        position: "absolute",
                        left: 32,
                        bottom: 32,
                      }}
                      onClick={() =>
                        setState({ ...state, page: (state.page || 0) - 1 })
                      }
                    >
                      tidigare
                    </button>
                  )}
                  {(state.page || 0) < state?.lundaGroups.length - 1 &&
                    !state?.lundaGroupSearch &&
                    !state?.lundaGroupSearch?.length && (
                      <button
                        style={{
                          ...buttonStyle,
                          position: "absolute",
                          right: 32,
                          bottom: 32,
                        }}
                        onClick={() =>
                          setState({ ...state, page: (state.page || 0) + 1 })
                        }
                      >
                        nästa
                      </button>
                    )}
                </div>
              )
            ) : secondMenu === 3 ? (
              !state?.currentUser ? (
                <Loading />
              ) : (
                <User
                  data={state.currentUser}
                  fetchBranteverestUserUpdate={fetchLundarundanUserUpdate}
                />
              )
            ) : secondMenu === 4 ? (
              !state?.currentGroup ? (
                <Loading />
              ) : (
                <Group
                  data={state.currentGroup}
                  fetchBranteverestGroupUpdate={fetchLundarundanGroupUpdate}
                />
              )
            ) : (
              <CreateGroup
                createGroupFunc={createLundarundanGroup}
                menu={menu}
              />
            ))
          )}
        </div>
      )}
    </div>
  );
};

/*  : secondMenu === 4 ? (
              !state?.currentGroup || state?.isLoading ? (
                <Loading />
              ) : (
                <Group
                  data={state.currentGroup}
                  fetchBranteverestGroupUpdate={fetchBranteverestGroupUpdate}
                />
              )
            ) : state?.isLoading ? (
              <Loading />
            ) : (
              <CreateGroup createGroupFunc={createBranteverestGroup} />
            )*/
